import { createFileRoute } from "@tanstack/react-router";
import { PracticeLibraryTab } from "@/components/practice/PracticeLibraryTab";
import { pageHead } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/practice/")({
  head: () =>
    pageHead({
      title: m.practice_meta_title(),
      description: m.practice_meta_description(),
      path: "/practice",
    }),
  component: PracticeHubPage,
});

function PracticeHubPage() {
  return (
    <>
      <section className="bg-ink page-band-pad text-foreground">
        <div className="container-page">
          <span className="text-xs font-semibold uppercase tracking-wider text-accent">
            {m.practice_eyebrow()}
          </span>
          <h1 className="mt-2 font-display text-4xl font-bold md:text-5xl">{m.practice_title()}</h1>
          <p className="mt-3 max-w-2xl text-foreground/70">{m.practice_subtitle()}</p>
        </div>
      </section>

      <section className="container-page page-content-pad">
        <PracticeLibraryTab />
      </section>
    </>
  );
}
